import { Injectable } from '@angular/core';
import { createClient } from 'contentful';
import { environment } from 'src/environments/environment';
import { ContentfulRateInfo, RateInfo } from '../shared/interfaces/contentfulInfo.interface';
import { AccountFormatService } from './account-format.service';
import { from } from 'rxjs';
@Injectable({
	providedIn: 'root'
})
export class ContentfulService {
	private rateInfo: RateInfo;

	private client = createClient({
		space: environment.contentful.space,
		accessToken: environment.contentful.accessToken,
		host: environment.contentful.host
	});


	constructor(private accountFormatService: AccountFormatService) {}

	public getEntriesFunction() {
		let accountType = this.accountFormatService.getName();
		if (accountType === 'AhorroSueldo') {
			accountType = 'Flex';
		}
		return from(this.client.getEntries<ContentfulRateInfo | any>({ 'content_type': 'accountRates', 'fields.accountType': accountType}));
	}

	public getContentfulEntries(): void {
		this.getEntriesFunction().subscribe({
			next: (entryCollection) => {
				if (entryCollection) {
					this.rateInfo = entryCollection.items[0].fields;
					// URL comes chopped so the http part has to be added manually
					this.rateInfo.backgroundImage.fields.file.url = `http:${this.rateInfo.backgroundImage.fields.file.url}`;
				}
			}
		});
		// this.rateInfo = contentfulRateInfo.items[0].fields;
		// // URL comes chopped so the http part has to be added manually
		// this.rateInfo.backgroundImage.fields.file.url = `http:${this.rateInfo.backgroundImage.fields.file.url}`;
	}

	public setRateInfo(rateInfo: ContentfulRateInfo | any) {
		this.rateInfo = rateInfo;
	}

	public getRateInfo(): RateInfo {
		return this.rateInfo;
	}
}
